import { BaseSyntheticEvent, useState } from 'react';
import axios from 'axios';
import './UsersEdit.scss';
import { Button, Stack, TextField } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AuthHeader } from '../../../utils/helpers/auth-headers';
import { setAlertData } from '../../../stores/alertStore';
import { AlertSeverity } from '../../../utils/enum/Alerts';

interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
}

interface UdpateUserPassword {
  _id: string;
  name: string;
  email: string;
  password?: string
  role: string;
}

function UsersEditPasswordForm({ selectedUser }: any) {
  const { t } = useTranslation();

  const { userId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [user] = useState<User>(selectedUser);

  const initErrorPassword = {
    passwordError: false,
    passwordHelper: '',
    confirmPasswordError: false,
    confirmPasswordHelper: '',
  };
  const [hasErrorPassword, setHasErrorPassword] = useState(initErrorPassword);
  const [updatePassword, setUpdatePassword] = useState({
    password: '',
    confirmPassword: ''
  });

  const handleChangePassword = (event: any) => {
    setUpdatePassword({ ...updatePassword, [event.target.name]: event.target.value });
  };

  const editUserPassword = () => {
    const modifyUser: UdpateUserPassword = user;
    modifyUser.password = updatePassword.password;
    axios.patch(`${window._env_.REACT_APP_API_URI}/user/${userId}`, modifyUser, { headers: AuthHeader() ? { Authorization: `Bearer ${AuthHeader()}` } : {} })
      .then(() => {
        navigate('/configuration/users');
      })
      .catch((error) => {
        if (error.response) {
          const err = error.response;
          console.error(err);
          dispatch(setAlertData({
            message: err.data.message,
            severity: AlertSeverity.ERROR,
            open: true,
          }));
        }
        console.error(error);
      });
  };

  const onEditUserPassword = (event: BaseSyntheticEvent) => {
    event.preventDefault();
    const tempErrorPassword = { ...initErrorPassword };
    if (updatePassword.password === '') {
      tempErrorPassword.passwordError = true;
      tempErrorPassword.passwordHelper = 'UsersEditPasswordForm.passwordRequired';
    }
    if (updatePassword.password.length < 6) {
      tempErrorPassword.passwordError = true;
      tempErrorPassword.passwordHelper = 'UsersEditPasswordForm.passwordTooShort';
    }
    if (updatePassword.confirmPassword === '') {
      tempErrorPassword.confirmPasswordError = true;
      tempErrorPassword.confirmPasswordHelper = 'UsersEditPasswordForm.confirmPasswordRequired';
    }
    if (updatePassword.confirmPassword.length < 6) {
      tempErrorPassword.confirmPasswordError = true;
      tempErrorPassword.confirmPasswordHelper = 'UsersEditPasswordForm.confirmPasswordTooShort';
    }
    if (updatePassword.password !== updatePassword.confirmPassword) {
      tempErrorPassword.confirmPasswordError = true;
      tempErrorPassword.confirmPasswordHelper = 'UsersEditPasswordForm.noMatch';
    }
    setHasErrorPassword(tempErrorPassword);
    if (_.isEqual(tempErrorPassword, initErrorPassword)) {
      editUserPassword();
    }
  };

  const cancelEdit = () => {
    navigate('/configuration/users');
  };

  return (
    <div>
      <form onSubmit={onEditUserPassword} className="form">
        <TextField
          variant="outlined"
          label={t('UsersEditPasswordForm.password')}
          error={hasErrorPassword.passwordError}
          helperText={hasErrorPassword.passwordError ? t(hasErrorPassword.passwordHelper) : ''}
          value={updatePassword.password}
          onChange={handleChangePassword}
          type="password"
          name="password"
          required
        />
        <TextField
          variant="outlined"
          label={t('UsersEditPasswordForm.confirmPassword')}
          error={hasErrorPassword.confirmPasswordError}
          helperText={hasErrorPassword.confirmPasswordError ? t(hasErrorPassword.confirmPasswordHelper) : ''}
          value={updatePassword.confirmPassword}
          onChange={handleChangePassword}
          type="password"
          name="confirmPassword"
          required
        />
        <Stack direction="row" spacing={2} alignSelf="center" width="100%">
          <Button fullWidth onClick={cancelEdit} variant="outlined">{ t('UsersEditPasswordForm.cancel') }</Button>
          <Button fullWidth type="submit" value="submit" variant="contained">{ t('UsersEditPasswordForm.submit') }</Button>
        </Stack>
      </form>
    </div>
  );
}

export default UsersEditPasswordForm;
